import { AbstractEntity } from "../AbstractEntity";
export default class Owner extends AbstractEntity {
    address;
    name;
    imoRegisteredOwnerNumber;
    constructor(address, name, imoRegisteredOwnerNumber) {
        super();
        this.address = address;
        this.name = name;
        this.imoRegisteredOwnerNumber = imoRegisteredOwnerNumber;
    }
}
//# sourceMappingURL=Owner.js.map